import AppDispatcher from '../utils/AppDispatcher';

import { actions as ActionTypes } from '../constants/UserConstants';
import AuthActions from './AuthActions';
import UserApi from '../api/UserApi';
import PosApi from '../api/PosApi';
import Cookies from 'universal-cookie';

import NotificationActions from './NotificationActions';
import GuestListActions from './GuestListActions';
import UserStore from '../stores/UserStore';
import * as _ from 'lodash';
import moment from 'moment';

var UserActions = {

    selectLocation: (location) => {
        var formData = UserStore.getApiData();
        formData.LocId = location.location_id;

        var cookies = new Cookies();
        var hardwareData = cookies.get('LeafLogixHardwareData', { path: '/' });
        formData.hardwareId = (hardwareData || {}).hardwareId;


        var promiseArr = [
            UserApi.loadRooms(formData),
            UserApi.getLocationSettings(formData),
            UserApi.getRegisterList(formData),
            PosApi.getAvailabelLabels(formData),
            PosApi.getAvailableReceiptPrinters(formData),
            PosApi.getAvailableLabelPrinters(formData),
            UserApi.loadCustomerTypes(formData),
            UserApi.getValidatedForms(formData),
            UserApi.getLaunchDarklyFlags(formData),
        ];

        return RSVP.all(promiseArr).then(res => {
            var flags = res[8].Data;
            var autoRedirectFlag = flags['pos.register.dutchie-pos-redirect.rollout'];
            var redirectUnlessOptedOutFlag = flags['pos.register.redirect-unless-opted-out.rollout'];

            if(autoRedirectFlag || (redirectUnlessOptedOutFlag && !localStorage.getItem('v1OptOut'))){
                AuthActions.goToDutchieRegister(formData, false);
                return
            }

            var locProfileConverted = { LocId: formData.LocId };

            _.map(res[1].Data.Features, (feature) => {
                locProfileConverted[feature.FeatureName] = feature.IsEnabled;
            });
            locProfileConverted = Object.assign(locProfileConverted,
                res[1].Data.Integrations,
                res[1].Data.Settings);


            location = Object.assign(location, locProfileConverted);

            setTimeout(() => {
                GuestListActions.loadGuestList(false);
            }, 100);

            if (location.CanUseMassDPHIntegration && location.RequireValidAllotmentCredentials) {
                UserActions.checkDPHCredentials(location.LocId, false);
            }

            AppDispatcher.dispatch({
                actionType: ActionTypes.SELECT_LOCATION,
                data: {
                    selectedLocation: location,
                    rooms: res[0].Data,
                    usePrintNode: !!res[1].Data.Settings.UsePrintNode,
                    registers: res[2].Data,
                    labels: res[3].Data ? res[3].Data : [],
                    receiptPrinters: res[4].Data || [],
                    labelPrinters: res[5].Data || [],
                    customerTypes: res[6].Data || [],
                    validatedForms: res[7].Data,
                    ldFlags: flags,
                },
            });
        });
    },

    getRegisterList: (formData) => {
        var location = UserStore.getState().selectedLocation;

        if (location.AssignRegistersToHardware) {
            var cookies = new Cookies();
            formData.hardwareId = cookies.get('LeafLogixHardwareData', { path: '/' });
        }

        var promise = UserApi.getRegisterList(formData);

        promise.then(res => {
            AppDispatcher.dispatch({
                actionType: ActionTypes.REGISTER_LIST,
                data: res.Result ? res.Data : false
            });
        });
    },

    selectRegister: (register) => {
        AppDispatcher.dispatch({
            actionType: ActionTypes.REGISTER_SELECTED,
            data: register
        });
    },

    selectRoom: (room) => {
        AppDispatcher.dispatch({
            actionType: ActionTypes.ROOM_SELECTED,
            data: room
        });
    },

    selectGuestListFilterArr: (room) => {
        AppDispatcher.dispatch({
            actionType: ActionTypes.ROOM_ARR_SELECTED,
            data: room
        });
    },

    clearGuestListFilterArr: () => {
        AppDispatcher.dispatch({
            actionType: ActionTypes.ROOM_ARR_CLEAR
        });
    },

    loadRooms: () => {
        UserApi.loadRooms(UserStore.getApiData()).then(res => {
            AppDispatcher.dispatch({
                actionType: ActionTypes.ROOMS_LOADED,
                data: res.Result ? res.Data : false
            });
        });
    },

    isDriversLicenseExpired(guest) {
        var ids = guest.identifications.filter(x => {
            return x.type === 'DriversLicenseId';
        });

        var dl = ids.length > 0 ? ids[0] : '';

        var date = moment(dl.ExpirationDate).format('YYYY-MM-DD');

        return (date === 'Invalid date' || moment(date).isBefore(moment()));
    },

    isMMJLicenseExpired(guest) {
        var ids = guest.identifications.filter(x => {
            return x.type === 'MJStateIDNo';
        });

        var dl = ids.length > 0 ? ids[0] : '';
        var date = moment(dl.ExpirationDate).format('YYYY-MM-DD');

        return (date === 'Invalid date' || (moment(date).isBefore(moment()) && !moment(date).isSame(moment(), 'day') ));
    },

    isMMJLicenseAboutExpire(guest) {
        var ids = guest.identifications.filter(x => {
            return x.type === 'MJStateIDNo';
        });

        var dl = ids.length > 0 ? ids[0] : '';
        var date = moment(dl.ExpirationDate).format('YYYY-MM-DD');
        var remainingDays = moment(date).diff(moment(), 'days');

        return (date === 'Invalid date' || (remainingDays <= 30 && remainingDays > 0));
    },

    mmjLicenseDaysFromExpiration(guest) {
        var ids = guest.identifications.filter(x => {
            return x.type === 'MJStateIDNo';
        });

        var dl = ids.length > 0 ? ids[0] : '';
        var date = moment(dl.ExpirationDate).format('YYYY-MM-DD');

        if (date !== 'Invalid date' && moment(date).isAfter(moment())) {
            var today = moment();
            var expirationDate = moment(date);
            return expirationDate.diff(today, 'days');
        } else {
            return 0;
        }
    },

    getMinorAge(locationSettings, isMedical) {
        if (isMedical) {
            return locationSettings.DefaultMinorAge || locationSettings.DefaultRecMinorAge || 18;
        }
        else {
            return locationSettings.DefaultRecMinorAge || locationSettings.DefaultMinorAge || 18;
        }
    },

    checkMinorStatus(guest, minimumAge) {
        let checkFlag = false;
        let guestDOB = guest.DOB ? guest.DOB : guest.Dob;
        let guestAge = moment().diff(guestDOB, 'years', true);

        if (guestAge < minimumAge || !moment(guest.DOB).isValid()) {
            checkFlag = true;
        }

        // If they were able to be checked in via Caregiver - allow them to be Selected in the GuestList
        if (guest.CheckInDate) {
            checkFlag = false;
        }

        return checkFlag;
    },

    checkAnonymousTransactionMinorStatus(guestDOB, minimumAge) {
        let checkFlag = false;
        let guestAge = moment().diff(guestDOB, 'years', true);

        if (guestAge < minimumAge) {
            checkFlag = true;
        }
        return checkFlag;
    },

    checkDPHCredentials:(locId, notifyOnSuccess) => {
        UserApi.checkDPHCredentials(UserStore.getApiData({
            LocId: locId
        })).then(res => {
            if (!res.Result) {
                NotificationActions.error('<div>Your DPH Credentials are invalid!</div><div>Go to settings and update to continue.</div><div style="margin-top: 20px;"><b>DPH Message: </b>' + res.Message + '</div>', true);
            }
            else {
                if (notifyOnSuccess) {
                    NotificationActions.success('Your DPH Credentials are valid.');
                }
            }

            AppDispatcher.dispatch({
                actionType: ActionTypes.TOGGLE_DPH_CREDENTIALS,
                data: res.Result
            });
        });
    },

    notification(message, type) {
        setTimeout(() => {
            NotificationActions.addNotification({
                type: type,
                body: message
            });
        }, 100);
    }
}

export default UserActions;



// WEBPACK FOOTER //
// ./ui_src/app/actions/UserActions.jsx